import { mutateDocuments } from "@/api/documentFile/useS3Query";
import { useModal } from "@/features/modal/ModalStackManager";
import customAlert from "@/features/ui/alert/Alert";
import { Box, Button, TextInput } from "@mantine/core";
import { S3ApiS3CreateFolderPostRequest } from "@sizlcorp/sizl-api-document/dist/models";
import { useMutation } from "@tanstack/react-query";
import { useState } from "react";

interface CreateFolderFormProps {
  currentPath: string | undefined;
  refetch: () => void;
}

export const CreateFolderForm = (params: CreateFolderFormProps) => {
  const { currentPath, refetch } = params;
  const { closeModal } = useModal();

  const [newFolderName, setNewFolderName] = useState("");

  const { mutate: folderMutate } = useMutation(
    (params: S3ApiS3CreateFolderPostRequest) =>
      mutateDocuments.createFolder(params).mutationFn(undefined),
    {
      onSuccess: () => {
        customAlert("폴더 생성에 성공하였습니다.", "폴더 생성", "green");
        closeModal("");
        refetch();
      },
      onError: (error: any) => {
        customAlert(
          error.response?.data?.message ?? "폴더 생성에 실패하였습니다.",
          "폴더 생성 실패",
          "red",
        );
      },
    },
  );

  return (
    <Box w="24rem">
      <TextInput
        label="폴더 이름"
        value={newFolderName}
        onChange={(event) => setNewFolderName(event.currentTarget.value)}
        placeholder="예: 자료실/2025"
      />
      <Button
        mt="md"
        fullWidth
        onClick={async () => {
          if (!newFolderName.trim()) {
            alert("폴더 이름을 입력해주세요.");
            return;
          }
          await folderMutate({
            s3CreateFolderPostRequest: {
              folderName: newFolderName,
              path: currentPath,
            },
          });
          setNewFolderName("");
          refetch();
        }}
      >
        생성
      </Button>
    </Box>
  );
};
